module.exports = __webpack_public_path__ + "img/brand (7).5a09a4e9.png";